export default __webpack_public_path__ + "static/media/Shell1.9d93724f.mp4";